
/* START_TEMPLATE */
define('hbs!app/views/templates/cartSummary',['hbs','Handlebars', 'hbs!app/views/templates/cartSummaryGuestItineraryPartial', 'hbs!app/views/templates/cartSummary_V2', 'hbs!app/views/templates/cartSummary_V1'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['app/views/templates/cartSummaryGuestItineraryPartial'],depth0,{"name":"app/views/templates/cartSummaryGuestItineraryPartial","data":data,"helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['app/views/templates/cartSummary_V2'],depth0,{"name":"app/views/templates/cartSummary_V2","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = this.invokePartial(partials['app/views/templates/cartSummary_V1'],depth0,{"name":"app/views/templates/cartSummary_V1","data":data,"indent":"    ","helpers":helpers,"partials":partials})) != null ? stack1 : "");
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,((stack1 = (depth0 != null ? depth0.Customization : depth0)) != null ? stack1.moveGuestItineraryToBookingSummaryBottom : stack1),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.Customization : depth0)) != null ? stack1.features : stack1)) != null ? stack1.updatedSummaryPage : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = (depth0 != null ? depth0.Customization : depth0)) != null ? stack1.moveGuestItineraryToBookingSummaryBottom : stack1),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.registerPartial('app/views/templates/cartSummary', t);
return t;
});
/* END_TEMPLATE */
;
